import { useQuery } from '@tanstack/react-query';
import { IWhoAmI } from "../../utils/types";
import { apiClient } from '../api-manager-instance';
import { ENDPOINTS } from '../endpoints';
import { getSessionCookie } from '../../utils/cookies';

export const useWhoAmI = () => {
  return useQuery({
    queryKey: ["who_am_i"],
    queryFn: async (): Promise<IWhoAmI> => {
      const res = await apiClient.get(ENDPOINTS.AUTH.WHOAMI);
      return res.data;
    },
    enabled: !!getSessionCookie("accessToken"),
    retry: false,
  });
};